/**
 * Shared storefront quote closer.
 * Creates the Shopify customer (no invite) and a draft via the TrackTECH Ops intake,
 * then lets the native contact form fire for the notification email.
 * Do not invent make/model. Attach the selected variant when the page has one.
 */
(function () {
  // 2026-10-22: the TrackTECH Ops intake is the single quote path (customer + draft + Ops record).
  var CLOSE_LOOP = "https://tracktech-ops-dashboard.vercel.app";

  function field(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? String(el.value || "").trim() : "";
  }

  function checked(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return !!(el && el.checked);
  }

  function phoneE164(raw) {
    var d = String(raw || "").replace(/\D/g, "");
    if (d.length === 11 && d.charAt(0) === "1") d = d.slice(1);
    return d.length === 10 ? "+1" + d : "";
  }

  function mark(form, selector, bad) {
    var el = form.querySelector(selector);
    if (!el) return;
    el.classList.toggle("is-invalid", !!bad);
  }

  function validate(form) {
    var name = field(form, "contact[name]");
    var email = field(form, "contact[email]");
    var phone = phoneE164(field(form, "contact[phone]"));
    var addr1 = field(form, "contact[Address 1]");
    var city = field(form, "contact[City]");
    var state = field(form, "contact[State]");
    var zip = field(form, "contact[ZIP]");
    var ok = true;
    mark(form, '[name="contact[name]"]', !name);
    mark(form, '[name="contact[email]"]', !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
    mark(form, '[name="contact[phone]"]', phone.length !== 12);
    mark(form, '[name="contact[Address 1]"]', !addr1);
    mark(form, '[name="contact[City]"]', !city);
    mark(form, '[name="contact[State]"]', !/^[A-Z]{2}$/.test(state));
    mark(form, '[name="contact[ZIP]"]', !/^\d{5}(-\d{4})?$/.test(zip));
    if (!name) ok = false;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) ok = false;
    if (phone.length !== 12) ok = false;
    if (!addr1 || !city || !/^[A-Z]{2}$/.test(state) || !/^\d{5}(-\d{4})?$/.test(zip)) ok = false;
    return ok;
  }

  function payloadFrom(form) {
    var ds = form.dataset;
    var title = ds.ttProductTitle || field(form, "contact[Product]");
    var variantId = ds.ttVariantId || field(form, "contact[Variant ID]");
    var size = ds.ttTrackSize || field(form, "contact[Track Size]");
    var notes = field(form, "contact[body]");
    return {
      customer_name: field(form, "contact[name]"),
      customer_email: field(form, "contact[email]").toLowerCase(),
      customer_phone: phoneE164(field(form, "contact[phone]")),
      company: field(form, "contact[company]"),
      address1: field(form, "contact[Address 1]"),
      address2: field(form, "contact[Address 2]"),
      city: field(form, "contact[City]"),
      state: field(form, "contact[State]"),
      shipping_zip: field(form, "contact[ZIP]"),
      product_title: title,
      shopify_variant_id: variantId,
      track_size: size,
      notes: notes,
      accepts_marketing: checked(form, "contact[Accepts Marketing]"),
      source: ds.ttQuoteSource || "product_faq",
      request_path: window.location.pathname + window.location.search,
      equipment_text: title,
      lines: variantId
        ? [{ shopify_variant_id: variantId, product_title: title, qty: 1 }]
        : title
          ? [{ shopify_variant_id: "", product_title: title, qty: 1 }]
          : []
    };
  }

  function postClose(payload) {
    return fetch(CLOSE_LOOP + "/api/storefront/quote-request", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "omit",
      body: JSON.stringify(payload || {})
    }).then(function (r) {
      return r.text().then(function (t) {
        var j = null;
        try { j = t ? JSON.parse(t) : null; } catch (e) { j = null; }
        if (!r.ok) throw new Error((j && j.error) || ("HTTP " + r.status));
        return j;
      });
    });
  }

  function showStatus(form, kind, text) {
    var el = form.querySelector("[data-tt-quote-status]");
    if (!el) return;
    el.hidden = !text;
    el.textContent = text || "";
    el.dataset.kind = kind || "";
  }

  function bind(form) {
    if (!form || form.dataset.ttQuoteBound === "1") return;
    form.dataset.ttQuoteBound = "1";
    if (!form.target) {
      var iframe = document.getElementById("tt-quote-close-target");
      if (!iframe) {
        iframe = document.createElement("iframe");
        iframe.name = "tt-quote-close-target";
        iframe.id = "tt-quote-close-target";
        iframe.className = "tt-quote-close-iframe";
        iframe.setAttribute("tabindex", "-1");
        iframe.setAttribute("aria-hidden", "true");
        iframe.style.cssText = "position:absolute;width:0;height:0;border:0;overflow:hidden";
        document.body.appendChild(iframe);
      }
      form.target = "tt-quote-close-target";
    }

    var zip = form.querySelector('[name="contact[ZIP]"]');
    if (zip) {
      zip.addEventListener("input", function () {
        var digits = this.value.replace(/\D/g, "").slice(0, 9);
        this.value = digits.length <= 5 ? digits : digits.slice(0, 5) + "-" + digits.slice(5);
      });
    }
    var phone = form.querySelector('[name="contact[phone]"]');
    if (phone) {
      phone.addEventListener("input", function () {
        var digits = this.value.replace(/\D/g, "").slice(0, 10);
        if (digits.length < 4) this.value = digits;
        else if (digits.length < 7) this.value = "(" + digits.slice(0, 3) + ") " + digits.slice(3);
        else this.value = "(" + digits.slice(0, 3) + ") " + digits.slice(3, 6) + "-" + digits.slice(6);
      });
    }

    form.addEventListener("submit", function (e) {
      if (form.dataset.ttqNative === "1") return;
      e.preventDefault();
      if (!validate(form)) {
        showStatus(form, "error", "Name, email, phone, and ship-to are required for the draft.");
        return;
      }
      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.dataset.ttLabel = btn.textContent;
        btn.textContent = "Creating quote…";
      }
      showStatus(form, "pending", "Saving your customer record and draft…");
      postClose(payloadFrom(form))
        .then(function (result) {
          var draft = (result && result.draft_order) || {};
          var nameEl = form.querySelector('[name="contact[Draft Order]"]');
          var adminEl = form.querySelector('[name="contact[Draft Admin URL]"]');
          var invoiceEl = form.querySelector('[name="contact[Customer Checkout URL]"]');
          if (nameEl) nameEl.value = draft.name || "";
          if (adminEl) adminEl.value = draft.admin_url || "";
          if (invoiceEl) invoiceEl.value = draft.invoice_url || (result && result.checkout_url) || "";
          showStatus(
            form,
            "ok",
            draft.name
              ? "Quote " + draft.name + " is in. We’ll follow up with pricing."
              : "Your quote is in. We’ll follow up with pricing."
          );
        })
        .catch(function (err) {
          showStatus(form, "error", (err && err.message) || "Draft save failed — sending the request anyway.");
        })
        .then(function () {
          form.dataset.ttqNative = "1";
          try { form.submit(); } catch (err) { /* ignore */ }
          if (btn) {
            btn.disabled = false;
            btn.textContent = btn.dataset.ttLabel || "Request Quote";
          }
        });
    });
  }

  function boot() {
    document.querySelectorAll("form[data-tt-quote-close], #faq-quote-form").forEach(bind);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
